import useSWR from 'swr'

import { newsApi, options } from '../../apis/suitebookClient'

export const useHotelNewsApi = (property?: string) => {
  const { data, isLoading, isValidating, error } = useSWR(
    property ? `/hotels/${property}/news` : null,
    property
      ? () => newsApi.getHotelNews(property, options).then((res) => res.data)
      : () => undefined,
    {
      revalidateOnFocus: false,
    }
  )

  return { data, isLoading, isValidating, error }
}
